let store = require("../store");
let actions = require("../actions");

let StudyDrop = require("../widget/StudyDrop");
let UserDrop = require("../widget/UserDrop");
let HelpDrop = require("../widget/HelpDrop");

class NavigationView extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    let { studies, user } = store.getState();

    return {
      studies,
      user
    };
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    if (this.state.user && this.state.studies.length === 0) {
      actions.loadStudies(store.getState().accountId);
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleStoreChange() {
    this.setState(this.getInitialState());
  }

  logout() {
    actions.logout().then(function () {
      mc.router.trigger("LOGIN_VIEW");
    });
  }

  requestPassword() {
    let email = store.getState().user.user.email;

    actions.requestPassword(email).then(function () {
      mc.ui.alert(tx("change_password_response", { email }));
    });
  }

  render() {
    let { user, studies } = this.state;
    let tokens = location.hash.match(/studies\/([\w-]+)\/(\w+)/);
    let studyId;
    let sectionId;
    let sections;
    let items = [];

    if (!user || !studies.length) {
      return null;
    }

    if (tokens) {
      studyId = tokens[1];
      sectionId = tokens[2];

      sections = [
        {
          path: mc.router.resolve("DESIGN_STUDY_VIEW", { studyId }),
          label: tx("design_study"),
          key: "design",
          pattern: /design/
        },
        {
          path: mc.router.resolve("SUBJECT_LIST_VIEW", { studyId }),
          label: tx("manage_study"),
          key: "subjects",
          pattern: /subjects/
        }
      ];

      items = sections.map(function (section) {
        return (
          <li key={section.key} data-key={section.key} role="tab" aria-checked={section.pattern.test(sectionId)}>
            <a href={section.path}>{section.label}</a>
          </li>
        );
      });
    }

    return (
      <div className="rc-navigation-view">
        <StudyDrop studies={studies} studyId={studyId}/>
        <ul id="rc-primary-nav" className="mc-screen" role="tablist">
          {items}
        </ul>
        <div id="rc-secondary-nav" className="mc-screen">
          <HelpDrop/>
          <UserDrop
            user={user.user}
            onRequestPassword={this.requestPassword.bind(this)}
            onLogout={this.logout.bind(this)}/>
        </div>
      </div>
    );
  }
}

module.exports = NavigationView;